export let api_host=process.env.REACT_APP_HOST || 'https://api.remontadafc.com/';
export let api_url=process.env.REACT_APP_API || 'https://api.remontadafc.com/api/';
export let basename=process.env.REACT_APP_BASENAME || '';
export let map_key=process.env.REACT_APP_MAP_KEY ||'AIzaSyBVofSHmm5fYuCQFYHlNSltQJhVjAi1H80';
export let notification_key=process.env.REACT_APP_NOTIFICATION_KEY ||'6d8f91472b72feaa5158';

